// extracted by mini-css-extract-plugin
module.exports = {"root_layout_wrapper":"styles_root_layout_wrapper__fOjpA","app_wrapper":"styles_app_wrapper__Xfzgu","main_section_wrapper":"styles_main_section_wrapper__v_F9m"};